import React, { useState } from 'react';
import { Typography, Button, Grid, TextField } from '@mui/material';
import { useHistory } from 'react-router-dom';
import CustomerLayout from '../CustomerLayout'; // ✅ correct relative path

const ProfileManagementCustomer = () => {
  // ✅ Your existing payment state (kept)
  const [paymentInfo, setPaymentInfo] = useState({
    cardNumber: '',
    cardholderName: '',
    expirationDate: '',
    cvv: '',
  });

  // ✅ Your existing toggler (kept)
  const [showPaymentManagement, setShowPaymentManagement] = useState(false);

  // ✅ NEW: minimal local customer state so the badge can compute.
  // When you later wire GET /api/customer/profile, call setCustomer(...) with real data.
  const [customer, setCustomer] = useState({
    customer_type: 'Individual', // 'Individual' | 'Business'
    phone: '',
    address: '',
    company_name: '',
    contact_name: ''
  });

  const history = useHistory();

 const handlePaymentManagement = (orderId) =>
  history.push(`/customer/payment-management?orderId=${orderId}`);

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    console.log('Payment Info:', paymentInfo);
  };

  const handleOrderHistory = () => history.push('/customer/order-history');
  const handleCustomerNotifications = () => history.push('/customer/customer-notifications');
  const handleFeedbackAndRatings = () => history.push('/customer/feedback-and-ratings');
  const handleSupportAndHelpCenter = () => history.push('/customer/support-and-help-center');
  const handleKnowledgeBase = () => history.push('/customer/knowledge-base');
  const handleCommunityForums = () => history.push('/customer/community-forums');
  const handleGettingStartedGuides = () => history.push('/customer/getting-started-guides');
  const handleLanguageAndLocalization = () => history.push('/customer/language-and-localization');
  const handleLiveChat = () => history.push('/customer/live-chat');
  const handleOrderCustomization = () => history.push('/customer/order-customization');
  const handleProductDocumentation = () => history.push('/customer/product-documentation');
  const handlePromotionsAndDiscounts = () => history.push('/customer/promotions-and-discounts');
  const handleRecommendations = () => history.push('/customer/recommendations');
  const handleReferralProgram = () => history.push('/customer/referral-program');
  const handleSocialSharing = () => history.push('/customer/social-sharing');
  const handleSubscriptionManagement = () => history.push('/customer/subscription-management');
  const handleTrackPackage = () => history.push('/customer/track-package');
  const handleTicketSystem = () => history.push('/customer/ticket-system');
  const handleVideoTutorials = () => history.push('/customer/video-tutorials');
  const handleCustomerSettingsAndPreferences = () => history.push('/customer/customer-settings-and-preferences');
  const handleCustomerCourierCommunication = () => history.push('/customer/customer-courier-communication');

  // ✅ Compute badge BEFORE return (this was the placement issue)
  const complete = customer?.customer_type === 'Business'
    ? Boolean(customer?.company_name && customer?.contact_name && customer?.address)
    : Boolean(customer?.phone && customer?.address);

  return (
    <CustomerLayout>
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant="h3" style={{ marginBottom: '20px' }}>
          Profile Management{' '}
          {complete
            ? <span style={{ fontSize: 14, color: '#2e7d32', marginLeft: 8 }}>✅ Complete</span>
            : <span style={{ fontSize: 14, color: '#ed6c02', marginLeft: 8 }}>⚠️ Missing info</span>}
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Button fullWidth variant="contained" color="primary" size="large" onClick={handleOrderHistory}>Load History</Button>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Button fullWidth variant="contained" color="primary" size="large" onClick={handleCustomerNotifications}>Notifications</Button>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Button fullWidth variant="contained" color="primary" size="large" onClick={handlePaymentManagement}>Payment Management</Button>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Button fullWidth variant="contained" color="primary" size="large" onClick={handleFeedbackAndRatings}>Feedback & Ratings</Button>
          </Grid>

          {/* All other buttons exactly as you had them */}
          {[
            { label: "Support & Help Center", handler: handleSupportAndHelpCenter },
            { label: "Knowledge Base", handler: handleKnowledgeBase },
            { label: "Community Forums", handler: handleCommunityForums },
            { label: "Getting Started Guides", handler: handleGettingStartedGuides },
            { label: "Language & Localization", handler: handleLanguageAndLocalization },
            { label: "Live Chat", handler: handleLiveChat },
            { label: "Load Customization", handler: handleOrderCustomization },
            { label: "Product Documentation", handler: handleProductDocumentation },
            { label: "Promotions & Discounts", handler: handlePromotionsAndDiscounts },
            { label: "Recommendations", handler: handleRecommendations },
            { label: "Referral Program", handler: handleReferralProgram },
            { label: "Social Sharing", handler: handleSocialSharing },
            { label: "Subscription Management", handler: handleSubscriptionManagement },
            { label: "Ticket System", handler: handleTicketSystem },
            { label: "Video Tutorials", handler: handleVideoTutorials },
            { label: "Track Load", handler: handleTrackPackage },
            { label: "Settings & Preferences", handler: handleCustomerSettingsAndPreferences },
            { label: "Driver Communication", handler: handleCustomerCourierCommunication },
          ].map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
              <Button fullWidth variant="contained" color="primary" size="large" onClick={item.handler}>
                {item.label}
              </Button>
            </Grid>
          ))}
        </Grid>

        {showPaymentManagement && (
          <form onSubmit={handlePaymentSubmit} style={{ marginTop: '30px' }}>
            <Typography variant="h5" gutterBottom>Payment Info</Typography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Card Number"
                  fullWidth
                  required
                  value={paymentInfo.cardNumber}
                  onChange={(e) => setPaymentInfo({ ...paymentInfo, cardNumber: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Cardholder Name"
                  fullWidth
                  required
                  value={paymentInfo.cardholderName}
                  onChange={(e) => setPaymentInfo({ ...paymentInfo, cardholderName: e.target.value })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Expiration Date"
                  fullWidth
                  required
                  value={paymentInfo.expirationDate}
                  onChange={(e) => setPaymentInfo({ ...paymentInfo, expirationDate: e.target.value })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="CVV"
                  fullWidth
                  required
                  value={paymentInfo.cvv}
                  onChange={(e) => setPaymentInfo({ ...paymentInfo, cvv: e.target.value })}
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="secondary">
                  Save Payment Info
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </div>
    </CustomerLayout>
  );
};

export default ProfileManagementCustomer;
